import React from 'react';
import { Link } from 'react-router-dom';
import { Zap, Twitter } from 'lucide-react';
import './Footer.css';

const Footer = () => {
    return (
        <footer className="footer">
            <div className="container footer-content">
                <div className="footer-brand">
                    <div className="logo">
                        <Zap className="logo-icon" size={20} />
                        <span className="text-gradient">OnlineToolSphere</span>
                    </div>
                    <p className="footer-desc">
                        Premium developer tools for the modern web. <br />
                        Built with performance and privacy in mind.
                    </p>
                </div>

                <div className="footer-links">
                    <div className="link-group">
                        <h4>Dev Tools</h4>
                        <a href="/tools/json-beautifier/">JSON Beautifier</a>
                        <a href="/tools/json-compare/">JSON Compare</a>
                        <a href="/tools/json-validator/">JSON Validator</a>
                        <a href="/tools/text-compare/">Text Compare</a>
                        <a href="/tools/color-picker/">Color Picker</a>
                        <a href="/tools/unit-converter/">Unit Converter</a>
                    </div>

                    <div className="link-group">
                        <h4>Image Tools</h4>
                        <a href="/tools/image-compressor/">Image Compressor</a>
                        <a href="/tools/image-crop/">Image Cropper</a>
                        <a href="/tools/image-converter/">Image Converter</a>
                        <a href="/tools/image-to-ico/">Image to ICO</a>
                        <a href="/tools/image-to-pdf/">Image to PDF</a>
                    </div>

                    <div className="link-group">
                        <h4>Project</h4>
                        <a href="#">About</a>
                        <Link to="/privacy/">Privacy</Link>
                        <a href="#">Terms</a>
                    </div>
                </div>
            </div>
            <div className="footer-bottom container">
                <p>&copy; {new Date().getFullYear()} OnlineToolSphere. All rights reserved.</p>
            </div>
        </footer>
    );
};

export default Footer;
